<span *ngIf="status && label" class="status-badge age-status-badge age-status-badge--{{ status | lowercase }}">
  {{ label }}
</span>
